import { render, staticRenderFns } from "./standart-switch.vue?vue&type=template&id=9795e50a&"
import script from "./standart-switch.vue?vue&type=script&lang=ts&"
export * from "./standart-switch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports